import { customElement, FASTElement } from '@microsoft/fast-element';

import template from './template.js';
import styles from './styles.js';

@customElement({
	name: 'call-to-action',
	template,
	styles
})
export class CTA extends FASTElement {}